import { createContext, ReactNode, useContext, useEffect, useRef, CSSProperties } from 'react'

const ScrollContext = createContext<any>(null)

export const useScrollContext = () => useContext(ScrollContext)

export const useScrollTopEffect = () => {
  const scrollElement = useScrollContext()
  useEffect(() => {
    if (scrollElement) {
      scrollElement.scrollTop = 0
    }
  }, [scrollElement])
}

export const ScrollY: React.FC<React.PropsWithChildren<{ children?: ReactNode; style?: CSSProperties }>> = ({ children, style }) => {
  const ref = useRef(null)
  return (
    <ScrollContext.Provider value={ref.current}>
      <div className="scroll-y" style={style} ref={ref}>
        {children}
      </div>
    </ScrollContext.Provider>
  )
}
